import * as Yup from 'yup';
import i18next from 'i18next';

export const invoicePaymentHistorySchema = () =>
  Yup.object().shape({
    date: Yup.string().required(i18next.t('validation.required')),
    price: Yup.number().required(i18next.t('validation.required')),
    payment_method: Yup.string().required(i18next.t('validation.required')),
  });
